// straightOptions.js

// 바로가기 옵션
export const STRAIGHT_OPTIONS = [
  {
    key: "gallery",
    title: "내 사진으로 이미지 생성",
    desc: "내 사진을 업로드해서 이미지를 만드는 화면으로 이동",
  },
  {
    key: "ai_manual",
    title: "AI 마케팅 생성",
    desc: "AI가 만들어 주는 마케팅 이미지를 생성하는 화면으로 이동",
  },
  {
    key: "ai_auto",
    title: "즉시 생성",
    desc: "추천 설정으로 이미지를 바로 생성하는 화면으로 이동",
  },
  {
    key: "none",
    title: "바로가기 없이 알림만 받기",
    desc: "",
  },
];
